import { render, staticRenderFns } from "./FutureLayerImageSuggested.vue?vue&type=template&id=5dbddb67&"
import script from "./FutureLayerImageSuggested.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerImageSuggested.vue?vue&type=script&lang=ts&"
import style0 from "./FutureLayerImageSuggested.vue?vue&type=style&index=0&id=5dbddb67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports